<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" value="{{ menuType }}" />
        <h2 id="pageTitle">{{ 'bss.pki.error.title' | translate }}</h2>
        <hr>
        <div>
            <p *ngIf="errorCode"><b>{{'bss.pki.error.code.title'|translate}} </b>{{ errorCode }}</p>
            <p *ngIf="errorMessage"> <b>{{'bss.pki.error.message.title'|translate}} </b>{{ errorMessage}}</p>

        </div>
    </div>
</div>